export class ContainerWiseAbstractModel{
    containerWiseAbstract : ContainerWiseAbstract[];
    countryWiseAbstract : CountryWiseAbstract[]

    constructor(containerWiseAbstract : ContainerWiseAbstract[],countryWiseAbstract : CountryWiseAbstract[]){
        this.containerWiseAbstract = containerWiseAbstract
        this.countryWiseAbstract = countryWiseAbstract
    }
   
}

export class ContainerWiseAbstract{
    poNumber : string;
    buyer : string;
    shortCode : string;
    grade : string;
    country : string;
    packStyle : string;
    totalQty : number;
    exchangeRate : number;
    rmCount : number;
    rmRate : number;
    rmCost : number;
    mfgCost : number;
    fixedCost : number;
    packingCost : number;
    freightAndForwardingCost : number;
    totalExpenses : number;
    totalCostOfSales : number;
    costOfSalesPerLbKgUsd : number;
    exportRate : number;
    pLPerLbKg : number;
    incentives : number;
    totalInUsdPLPerLbKg : number;
    toatlPLInInr : number;

    constructor( poNumber : string,buyer : string,shortCode : string,grade : string,country : string,packStyle : string,totalQty : number,exchangeRate : number,rmCount : number,rmRate : number,rmCost : number,mfgCost : number,fixedCost : number,packingCost : number,freightAndForwardingCost : number,totalExpenses : number,totalCostOfSales : number,costOfSalesPerLbKgUsd : number,exportRate : number,pLPerLbKg : number,incentives : number,totalInUsdPLPerLbKg : number,toatlPLInInr : number){
        this.poNumber = poNumber 
        this.buyer = buyer 
        this.shortCode = shortCode 
        this.grade = grade 
        this.country = country 
        this.packStyle = packStyle 
        this.totalQty = totalQty 
        this.exchangeRate = exchangeRate 
        this.rmCount = rmCount 
        this.rmRate = rmRate 
        this.rmCost = rmCost 
        this.mfgCost = mfgCost 
        this.fixedCost = fixedCost 
        this.packingCost = packingCost 
        this.freightAndForwardingCost = freightAndForwardingCost 
        this.totalExpenses = totalExpenses 
        this.totalCostOfSales = totalCostOfSales 
        this.costOfSalesPerLbKgUsd = costOfSalesPerLbKgUsd 
        this.exportRate = exportRate 
        this.pLPerLbKg = pLPerLbKg 
        this.incentives = incentives 
        this.totalInUsdPLPerLbKg = totalInUsdPLPerLbKg 
        this.toatlPLInInr = toatlPLInInr 
    }
}

export class CountryWiseAbstract{
    country: string;
    noOfFcl : number;
    plInInr : number;

    constructor(country:string,noOfFcl:number,plInInr:number){
        this.country = country
        this.noOfFcl = noOfFcl
        this.plInInr = plInInr
    }
}